module.exports = __webpack_public_path__ + "img/video.a19fe66f.gif";